import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';


import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";


const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
// var to_Date_val;

const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';


const exportToCSV = (csvData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventoryData = this.fetchInventoryData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',


    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      showFromErr: false

    })
    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({
        fromdate: ""
      })
      From_Date_val = ""
    }


  }


  fetchInventoryData() {


    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })
    const payload = {
      location: this.state.selectedLocation,
      date: From_Date_val,
      request_type: "view"
    }
    API.post('/reports/dailyinventoryreports/v1/', { param: payload })
    // axios
    //   .post(
    //     "http://" + url + "/reports/dailyinventoryreports/v1/",

    //     {
    //       location: this.state.selectedLocation,
    //       date: From_Date_val,
    //       request_type: "view"
    //     },

    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: this.state.userName,
    //       },
    //     }
    //   )

      .then(response => response.data)

      .then(data => {

        this.setState({ posts: data.data })

      })

      .then(async () => {

        this.setState({ tableRows: this.assemblePosts(), isLoading: false })


      });
  }
  downloadReport = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      date: From_Date_val,
      request_type: "download"
    };

    API.post('/reports/dailyinventoryreports/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loading: false
        });

        window.location.href = data.data[0]
      })
      .catch(function (error) { });
  };
  assemblePosts = () => {

    let posts = this.state.posts.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {

          warehouse: post.warehouse,

          brand: post.brand,

          lb_sku_id: post.lb_sku_id,

          lbSkuProductName: post.lb_sku_product_name,

          base_pack: post.basepack_code,

          pkd: post.pkd,

          mrp: post.mrp,

          cbu_code: post.cbu_code,

          sku7_code: post.sku7_code,

          bin_address: post.Bin_ID,

          quantity: post.qty,

          pre_alloc_qty: post.pre_alloc_qty,

          putaway_staging: post.putaway_staging,

          ptl_staging: post.ptl_staging,

          receiving_staging: post.receiving_staging,

          z_missing: post.z_missing,

          z_damaged: post.z_damaged,

          z_expiry: post.z_expiry,


        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {


    const data = {

      columns: [

        {

          label: ' Warehouse',

          field: 'warehouse',
          sort: 'asc',
          width: 130,

        },

        {

          label: 'Brand',

          field: 'brand',
          sort: 'asc',
          width: 130,

        },

        {

          label: 'Jarvis Product ID',

          field: 'lb_sku_id',
          width: 150,
          sort: 'asc',

        },


        {

          label: 'Product Name',

          field: 'lbSkuProductName',
          width: 200,
          sort: 'asc',

        },

        {

          label: 'Basepack Code',

          field: 'base_pack',
          width: 130,
          sort: 'asc',

        },

        {

          label: 'PKD',

          field: 'pkd',
          width: 110,
          sort: 'asc',

        },
        {

          label: 'MRP',

          field: 'mrp',
          width: 110,
          sort: 'asc',

        },

        {

          label: 'CBU Code',

          field: 'cbu_code',
          width: 120,
          sort: 'asc',

        },

        {

          label: 'SKU7Code',

          field: 'sku7_code',
          width: 120,
          sort: 'asc',

        },

        {

          label: 'Quantity (pcs)',

          field: 'quantity',
          width: 150,
          sort: 'asc',

        },

        {

          label: 'Pre Alloc Qty (pcs)',

          field: 'pre_alloc_qty',
          width: 150,
          sort: 'asc',

        },
        {
          label: 'Putaway_staging',
          field: 'putaway_staging',
          width: 130,
          sort: 'asc',
        },

        {
          label: 'Ptl_staging',
          field: 'ptl_staging',
          width: 130,
          sort: 'asc',
        },

        {
          label: 'Receiving_staging',
          field: 'receiving_staging',
          width: 130,
          sort: 'asc',
        },

        {
          label: 'Z_missing',
          field: 'z_missing',
          width: 100,
          sort: 'asc',
        },
        {
          label: 'Z_damaged',
          field: 'z_damaged',
          width: 100,
          sort: 'asc',
        },
        {
          label: 'Z_expiry',
          field: 'z_expiry',
          width: 100,
          sort: 'asc',
        },

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
        <CardBody style={{ paddingTop: 22, height: 100, marginTop : "-20px",paddingBottom: 0 }}>
          <form className="form" >

            <div style={{ width: '15%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="Date"
                format='yyyy-MM-dd'

              />

              {this.state.showFromErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
              }
            </div>

            <div style={{ width: '15%', marginBottom: '0px', marginLeft: "20px", float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={() => this.fetchInventoryData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  View
                </Button>
              </ButtonToolbar>
            </div>
            <div style={{ width: '6%', marginBottom: '0px', float: 'left' }}>
              <Button type="button" className="btn btn-primary-outline"
                style={{
                  cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                  backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                }}
                id="button_enable"
                onClick={this.downloadReport}
              >

                <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} />
              </Button>
            </div>

          </form>
          </CardBody>
          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 20 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">Reports</h4>

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  data={data}
                  style={{ textAlign: "center" }}
                />
              </CardBody>

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));